export default import.meta.ROLLDOWN_FILE_URL_vIfA5llHCki2L2hJqsybqg